export const EMPTY_QUILL_RE = /^<p>( |<br>)?<\/p>$/g;
